import React from "react";
import BlogNine from "../component/BlogNine";

function BlogNineContainer() {
  return <BlogNine />;
}
export default BlogNineContainer;
